<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>项目详情</span>
      <span>
        <el-button
          type="primary"
          style="width: 92px"
          size="medium"
          @click="saveMsg"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('293') : false
          "
        >保存</el-button>
        <el-button
          plain
          style="width: 92px"
          size="medium"
          @click="back"
        >返回</el-button>
      </span>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="item align-center">
          <span class="title"> <span class="must">*</span>项目名称名称 </span>
          <el-input
            v-model="pro_name"
            placeholder="请输入10位以内汉字或字符"
            style="width: 240px"
            maxlength="10"
          ></el-input>
        </div>
        <div class="item align-center">
          <span class="title"> <span class="must">*</span>销售价格 </span>
          <el-input
            v-model="price"
            style="width: 240px"
            maxlength="10"
            placeholder="请输入2位小数以内数字"
          ></el-input>
        </div>
        <div class="item align-center">
          <span class="title"> <span class="must">*</span>推荐奖励 </span>
          <el-input
            v-model="reward_price"
            style="width: 240px"
            maxlength="10"
            placeholder="请输入2位小数以内数字"
          ></el-input>
          <span style="color: #f59a23; margin-left: 10px">推荐奖励不能大于销售价格</span>
        </div>
        <div
          class="flex align-center"
          style="margin: 10px 0"
        >
          <span style="color: #e93528; margin-right: 3px">*</span>
          <span style="display: inline-block; width: 100px; font-weight: 700">项目图文介绍</span>
        </div>
        <div style="padding-left: 14px; text-align: left">
          <span>患者端详情图片</span>
          <span style="color: #f59a23; margin-left: 10px">显示到患者端详情页面(可上传多张)</span>
        </div>

        <div class="imglist">
          <div
            class="imgbox"
            v-for="(item, index) in patientList"
            :key="index"
          >
            <el-upload
              class="avatar-uploader"
              name="image"
              accept=".png,.jpeg,.jpg"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="
                (res, file, fileList) => {
                  handleAvatarSuccess(
                    res,
                    file,
                    fileList,
                    index,
                    'patientList'
                  );
                }
              "
              :before-upload="beforeAvatarUpload"
            >
              <div
                v-if="item.image"
                class="delbox"
                @click="delImg(index, 'patientList')"
              >
                <i class="el-icon-delete delico"></i>
              </div>
              <img
                v-if="item.image"
                :src="item.image_str"
                class="avatar"
              />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </div>
          <div class="imgbox">
            <el-upload
              class="avatar-uploader"
              name="image"
              accept=".png,.jpeg,.jpg"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="
                (res, file, fileList) => {
                  return imgListSuccess(res, file, fileList, 'patientList');
                }
              "
              :before-upload="beforeAvatarUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
        <div style="padding-left: 14px; text-align: left; margin-bottom: 10px">
          <span>医生端详情图片</span>
          <span style="color: #f59a23; margin-left: 10px">显示到医生端详情页面</span>
        </div>

        <div class="imglist">
          <div
            class="imgbox"
            v-for="(item, index) in doctorList"
            :key="index"
          >
            <el-upload
              class="avatar-uploader"
              name="image"
              accept=".png,.jpeg,.jpg"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="
                (res, file, fileList) => {
                  handleAvatarSuccess(res, file, fileList, index, 'doctorList');
                }
              "
              :before-upload="beforeAvatarUpload"
            >
              <div
                v-if="item.image"
                class="delbox"
                @click="delImg(index, 'doctorList')"
              >
                <i class="el-icon-delete delico"></i>
              </div>
              <img
                v-if="item.image"
                :src="item.image_str"
                class="avatar"
              />
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </div>
          <div class="imgbox">
            <el-upload
              class="avatar-uploader"
              name="image"
              accept=".png,.jpeg,.jpg"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="
                (res, file, fileList) => {
                  return imgListSuccess(res, file, fileList, 'doctorList');
                }
              "
              :before-upload="beforeAvatarUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constant from '../../../service/common/constant';
import marketing from '../../../api/marketing';

export default {
  data() {
    return {
      pro_name: '',
      price: '',
      reward_price: '',
      uploadExtraData: {
        img_type: 4,
        suffix: '.jpg'
      },
      patientList: [],
      doctorList: [],
      doctor_desc: '',
      doctor_desc_str: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },
  methods: {
    back() {
      history.back();
    },
    //图片列表
    imgListSuccess(res, file, fileList, listName) {
      if (res.code === 0) {
        let data = {
          image: res.data.pic,
          image_str: res.data.path
        };
        this[listName].push(data);
      }
    },
    //图片上传成功
    handleAvatarSuccess(res, file, fileList, index, listName) {
      if (res.code === 0) {
        let data = {
          image: res.data.pic,
          image_str: res.data.path
        };
        this.$set(this[listName], index, data);
      }
    },
    dataURItoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
      const _this = this;
      return new Promise((resolve) => {
        const reader = new FileReader();
        const image = new Image();
        image.onload = (imageEvent) => {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const width = 750;
          const height = (750 / image.width) * image.height;
          canvas.width = width;
          canvas.height = height;
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL(file.type);
          const blobData = _this.dataURItoFile(dataUrl, file.name);
          resolve(blobData);
        };
        reader.onload = (e) => {
          image.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    //删除患者图片
    delImg(index, listName) {
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this[listName].splice(index, 1);
    },
    //保存
    saveMsg() {
      if (!this.pro_name) {
        this.$message.error('请填写项目名称');
        return false;
      }
      if (!this.price) {
        this.$message.error('请填写项目销售价格');
        return false;
      }
      if (!this.reward_price) {
        this.$message.error('请填写推荐奖励金额');
        return false;
      }
      if (!this.patientList.length) {
        this.$message.error('请上传患者端详情图片');
        return false;
      }
      if (!this.doctorList.length) {
        this.$message.error('请上传医生端详情图片');
        return false;
      }
      let reg = /^\d+(\.\d{0,2})?$/;
      if (reg.test(this.price) && reg.test(this.reward_price)) {
        if (Number(this.reward_price) > Number(this.price)) {
          this.$message.error('推荐奖励不能大于销售价格');
          return false;
        }
      } else {
        this.$message.error('请输入正确的金额');
        return false;
      }
      let user_desc_arr = this.patientList.map((item) => {
        return item.image;
      });
      let doctor_desc_arr = this.doctorList.map((item) => {
        return item.image;
      });
      let data = {
        pro_id: this.$route.query.pro_id,
        pro_name: this.pro_name,
        price: this.price,
        reward_price: this.reward_price,
        user_desc: user_desc_arr.toString(),
        doctor_desc: doctor_desc_arr.toString()
      };
      marketing.editProductDetail(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.getMsg();
        }
      });
    },
    //获取详情
    getMsg() {
      let pro_id = this.$route.query.pro_id;
      marketing.getProductDetail({ pro_id }).then((res) => {
        if (res.code == 0) {
          let detail = res.data.info;
          this.pro_name = detail.pro_name;
          this.price = detail.price;
          this.reward_price = detail.reward_price;
          detail.user_desc.map((item, index) => {
            this.patientList[index] = {};
            this.patientList[index].image = item;
            this.patientList[index].image_str = detail.user_desc_str[index];
          });
          detail.doctor_desc.map((item, index) => {
            this.doctorList[index] = {};
            this.doctorList[index].image = item;
            this.doctorList[index].image_str = detail.doctor_desc_str[index];
          });
        }
      });
    }
  },
  created() {
    this.getMsg();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.box {
  width: 100%;
  box-sizing: border-box;
}

.item {
  display: flex;
  margin-bottom: 20px;
  .must {
    color: #e93528;
    margin-right: 3px;
  }
  .title {
    display: inline-block;
    font-weight: 700;
    text-align: right;
    margin-right: 10px;
    width: 100px;
  }
}
.imglist {
  display: flex;
  padding: 10px 0 10px 14px;
  box-sizing: border-box;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.imgbox {
  width: 200px;
  height: 144px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  &:hover {
    .delbox {
      display: block;
    }
  }
  .delbox {
    position: absolute;
    bottom: 0px;
    text-align: center;
    background: #ccc;
    box-sizing: border-box;
    width: 198px;
    height: 30px;
    display: none;
    .delico {
      color: #fff;
      font-size: 20px;
      line-height: 30px;
    }
  }
}
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 32px;
  color: #8c939d;
  font-weight: 600;
  width: 198px;
  height: 142px;
  line-height: 144px;
  text-align: center;
}
.avatar {
  width: 198px;
  height: 142px;
  display: block;
}
</style>
